<template>
    <div>
        <breadCrumb 
            :icon="'fa-user'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_user`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-if="!addToggle && addUserPermission" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New User" @click="addToggle = !addToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_user`)}}</span>
            </button>
        </div>
        <div v-if="!addToggle">
            <userList></userList>
        </div>
        <div v-else class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2><span>{{$t('header.add')}}{{$t(`subMenu.my_salon_user`)}}</span></h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <userForm @returnUserList="returnUserList"></userForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import UserList from './User_List'
import UserForm from './User_Form'
export default {
    name: 'user',
    components:{
       UserList, UserForm, BreadCrumb
    },
    data(){
        return{
            category: "My Salon", subCategory: "User",
            addToggle: false, userListKey: 0,
            addUserPermission: true,
        }
    },
    methods:{
        returnUserList(){
            this.addToggle = false;
        },
    },
    async mounted(){
        let $vm = this;
        var blockList = $vm.$store.state.blockList
        for(var i=0; i<blockList.length; i++){
            if(blockList[i] == "biz.user.add"){
                $vm.addUserPermission = false;
                break
            }
        }
    }

}
</script>